export const platformAdminCommon = {
  open: "Open",
  openPortal: "Open Portal",
  openExamAdmin: "Open Exam Admin",
  consolePage: "Console",
  modulePage: "Module",
  detail: "Status Detail",
  endpoint: "Endpoint URL",
  phase: "Phase",
  statusCodeLatency: "HTTP {status} · {latency} ms",
  probeStatusCode: "Probe HTTP Status",
  probeLatency: "Probe Latency",
  checkedAt: "Last Checked At",
  latestError: "Latest Error",
  latestCheckSuccess: "No error was found in the latest probe.",
  probeErrors: {
    urlUnavailable: "The health check URL is unavailable",
    httpError: "The probe returned HTTP {status}",
    timeout: "The probe timed out after {timeout_ms} ms",
    requestAborted: "The probe request was aborted",
    networkUnreachable: "The probe could not reach the target service",
    requestFailed: "The probe request failed",
  },
  planning: "Planned",
  pageNotFound: "Page not found.",
  backToAdmin: "Back to Platform Admin",
  domainLabel: "Domain: {value}",
  latencyLabel: "Latency: {value}",
} as const;
